// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { etherlinkTestnet as _etherlinkTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the etherlinkTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 128123
 * Chain Name: Etherlink Testnet
 * Default Block Explorer: https://testnet-explorer.etherlink.com
 * Default RPC URL: https://node.ghostnet.etherlink.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { etherlinkTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: etherlinkTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const etherlinkTestnet = createCommon({
	..._etherlinkTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
